import { useEffect } from "react";

export default function useMount(fn) {
    useEffect(() => {
        fn();
        // eslint-disable-next-line
    }, []);
}
